:where(a, button) {
  all: unset;
}

*,
::before,
::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  width: 100%;
  height: 100%;
}

:host([force-containing-block]) {
  transform: translateX(0);
  --ch-window-relative-position: true;
}

.action {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: start;
}

.start-img,
.end-img {
  display: block;
  width: 24px;
  height: 24px;
  min-width: 24px;
}

.content {
  width: 100%;
}